(function() {
  var BaseHandler, SidebarKo,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SidebarKo = App.loadClass("core::viewmodels/filters/Sidebar");

  BaseHandler = App.loadClass("core::reports/BaseHandler");

  exports.Communicate_Handler = (function(superClass) {
    extend(Communicate_Handler, superClass);

    function Communicate_Handler() {
      return Communicate_Handler.__super__.constructor.apply(this, arguments);
    }

    Communicate_Handler.prototype.init = function(filterUrl, imp_structure) {
      if (filterUrl == null) {
        filterUrl = null;
      }
      this.imp_structure = imp_structure != null ? imp_structure : null;
      this.filterUrl = filterUrl != null ? filterUrl : 'backend/portal/communicate/filters';
      this.layoutUrl = 'backend/portal/communicate/';
      return this.loadLayout();
    };

    Communicate_Handler.prototype.afterLoadLayout = function() {
      this.initFilters();
      $(this.layoutSelector).find('.apply-filters').bind('click', (function(_this) {
        return function() {
          return _this.message_dialog.populateBcc();
        };
      })(this));
      $(this.layoutSelector).find('.clear-filters').bind('click', (function(_this) {
        return function() {
          _this.message_dialog.emptyUsersFromBcc();
          return _this.message_dialog.clearUploadedFile();
        };
      })(this));
      $(this.layoutSelector).find('.report-applied-filters').undelegate().delegate('.applied-filter-header', 'click', function() {
        $(this).siblings('.applied-filter-value-container').slideToggle('fast');
        if ($(this).find('.caret-arrow').hasClass('caret-right')) {
          return $(this).find('.caret-arrow').removeClass('caret-right');
        } else {
          return $(this).find('.caret-arrow').addClass('caret-right');
        }
      });
      return this.sidebar.fetchFilters(this.filterUrl, (function(_this) {
        return function() {
          _this.message_dialog = _this.createSubHandler('portal::handlers/communicate/Communicate_Dialog');
          if (_this.message_dialog) {
            return _this.message_dialog.init(_this.imp_structure != null);
          }
        };
      })(this));
    };

    Communicate_Handler.prototype.initFilters = function() {
      var filters;
      if (this.imp_structure != null) {
        filters = this.imp_structure;
      } else {
        filters = [
          {
            name: 'Region Filters',
            filters: [
              {
                name: 'states',
                display_name: 'State'
              }, {
                name: 'zones',
                display_name: 'Zone'
              }, {
                name: 'zips',
                display_name: 'ZIP Code'
              }
            ]
          }, {
            name: "Operation Filters",
            filters: [
              {
                name: 'companies',
                display_name: 'Company'
              }, {
                name: 'account_types',
                display_name: 'Account Type',
                "class": 'dropup'
              }, {
                name: 'farms',
                display_name: 'Farm',
                "class": 'dropup'
              }, {
                name: 'fields',
                display_name: 'Field',
                "class": 'dropup'
              }
            ]
          }, {
            name: "Communicate Filters",
            filters: [
              {
                name: 'last_interaction',
                display_name: 'Last Touchpoint',
                control_type: 'datepicker'
              }, {
                name: 'methods',
                display_name: 'Contact Method',
                "class": 'dropup',
                control_type: 'single_dropdown',
                deletable: false,
                values: [
                  {
                    key: 'Email',
                    value: 'Email + TouchPoint'
                  }, {
                    key: 'SMS',
                    value: 'SMS + TouchPoint'
                  }, {
                    key: 'TouchPoint',
                    value: 'TouchPoint'
                  }
                ],
                selected_values: [
                  {
                    key: 'TouchPoint',
                    value: 'TouchPoint'
                  }
                ]
              }, {
                name: 'owners',
                display_name: 'User',
                "class": 'dropup'
              }
            ]
          }
        ];
      }
      this.sidebar = new SidebarKo(filters);
      ko.cleanNode($(this.layoutSelector)[0]);
      return ko.applyBindings(this.sidebar, $(this.layoutSelector)[0]);
    };

    return Communicate_Handler;

  })(BaseHandler);

}).call(this);
